<template>
  <div
    id="app"
    class="relative"
    :class="{
      public: isPublicView,
      'has-footer': userType === 'admin'
    }"
  >
    <navbar v-if="!isPublicView" style="grid-area: navbar;" />
    <mobile-menu v-if="mobileNavIsOpen" />
    <sidebar
      v-if="!isPublicView"
      class="hidden md:flex h-full"
      style="grid-area: sidebar"
    />
    <confirmation-modal v-if="confirmationModalIsShown" />
    <component :is="modalComponent" v-if="modalIsShown" />
    <div class="main-content" style="grid-area: main; overflow-y: scroll">
      <router-view />
    </div>
    <bdg-footer
      style="grid-area: footer;"
      v-if="$mq === 'sm' && !isPublicView && userType === 'admin'"
    />

    <div
      class="absolute z-40 bg-black
      opacity-50 top-0 right-0 bottom-0 left-0"
      :class="{ overlay: sideDrawerIsOpen }"
      v-if="sideDrawerIsOpen"
    ></div>
    <create-edit-view-layout v-if="sideDrawerIsOpen" />

    <feedback-toasts />
  </div>
</template>

<script>
import Navbar from "./components/chroming/Navbar";
import BdgFooter from "./components/chroming/BdgFooter";
import Sidebar from "./components/chroming/Sidebar";
import MobileMenu from "./components/chroming/MobileMenu";
import CreateEditViewLayout from "./views/layouts/CreateEditViewLayout";
import ConfirmationModal from "./components/modals/ConfirmationModal";
import FeedbackToasts from "./components/FeedbackToasts";

export default {
  components: {
    FeedbackToasts,
    ConfirmationModal,
    CreateEditViewLayout,
    MobileMenu,
    Sidebar,
    BdgFooter,
    Navbar
  },
  computed: {
    userType() {
      return this.$store.state.userType;
    },
    mobileNavIsOpen() {
      return this.$store.state.isMobileNavOpen;
    },
    sideDrawerIsOpen() {
      return this.$store.state.CreateEditViewLayout.createEditComponentIsShown;
    },
    confirmationModalIsShown() {
      return this.$store.state.ConfirmationModal.isShown;
    },
    modalIsShown() {
      return this.$store.state.Modal.isShown;
    },
    modalComponent() {
      return this.$store.state.Modal.component;
    },
    isPublicView() {
      return this.$route.meta.publicView;
    }
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name) {
        this.$store.commit("resetCreateEditComponentParams");
        this.$store.commit("setAreSearchResultsShown", false);
      }
    }
  }
};
</script>

<style lang="scss">
// Import our Font Awesome styles into the app
@import "~@fortawesome/fontawesome-pro/css/all.css";
@import "scss/variables";
@import "../bdg-shared-assets/scss/icons";

$footerHeight: 65px;
$headerHeight: 57px;
$bodyHeight: calc(100vh - #{$footerHeight} - #{$headerHeight});

div#app {
  min-height: 100vh;

  &:not(.public) {
    display: grid;

    grid-template-rows: $headerHeight $bodyHeight $footerHeight;
    grid-template-columns: 1fr;
    grid-template-areas:
      "navbar"
      "main"
      "footer";

    &:not(.has-footer) {
      $bodyHeight: (calc(100vh - #{$headerHeight}));
      grid-template-rows: $headerHeight $bodyHeight;
      grid-template-areas:
        "navbar"
        "main";
    }

    &.has-footer {
      grid-template-rows: $headerHeight $bodyHeight $footerHeight;
      grid-template-areas:
        "navbar"
        "main"
        "footer";
    }

    &:not(.has-footer),
    &.has-footer {
      //noinspection CssInvalidAtRule
      @screen md {
        grid-template-columns: $sidebar-width 1fr;
        grid-template-rows: 10vh 90vh;
        grid-template-areas:
          "navbar navbar"
          "sidebar main";
      }
    }

    .main-content {
      grid-area: navbar;
    }
  }

  &.public {
    @apply bg-lightgray-lightest;
  }

  .main-content {
    height: 100%;
  }
}
</style>
